<template>
  <div v-if="brand === 'mcom'" class="grid-container page-not-found">
    <div class="grid-x small-margin-bottom-xl small-margin-top-s medium-margin-bottom-xxl medium-margin-top-s large-margin-top-xxl">
      <div class="cell small-12 large-3 small-margin-bottom-xl image-container">
        <img src="https://www.macys.com/img/error-pages/404/11Fx2011.35_404.gif" alt="not found" />
      </div>
      <div class="cell small-12 large-9">
        <h1 class="h4 small-margin-bottom-xs medium-margin-bottom-xxs">
          We've searched high and low, but the web address you entered can't be found or no longer exists.
        </h1>
        <p class="large margin-bottom-m">
          Please double check the address you entered and try again—or feel free to keep shopping throughout the rest of the site!
        </p>
        <a href="https://www.macys.com/" class="emphasis button margin-bottom-m" role="button">Back to Homepage</a>
        <p class="margin-bottom-xs">
          Questions? Visit
          <a href="https://www.macys.com/customer-service" class="link-m">customer service</a>
          online to find answers and get help 24/7.
        </p>
        <p class="margin-bottom-xs">Thanks for shopping with us!</p>
        <p class="margin-bottom-xs">
          <a href="https://www.macys.com/stores/" class="link-m">Find a store near you</a>
        </p>
      </div>
    </div>
  </div>
  <div v-else class="main-container grid-container padding-m margin-top-l margin-bottom-l page-not-found">
    <div class="text-center">
      <h2 class="padding-top-m padding-bottom-m">404 ERROR</h2>
      <div class="padding-bottom-m">
        <p class="padding-top-xxs padding-bottom-xxs">
          <b>Oops! Looks like this page is no longer in style.</b>
        </p>
        <p>
          Try visiting our <a href="https://">homepage</a>,
          <a href="https://www.bloomingdales.com/customer-service/app/contact/" target="_blank">contact us</a> for help or call Customer Service at
          <span>{{ phoneNumbers[brand] }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { phoneNumbers } from '@/utils/constants';
const brand = import.meta.env.VITE_ENTRY_POINT;
</script>

<style lang="scss" scoped>
.main-container {
  max-width: 900px;
}
.page-not-found {
  .image-container {
    text-align: center;
  }

  .button {
    width: 219px;
  }
}
</style>
